import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '@/app/store/index.ts'
import Work from '@/app/modules/work/Work.vue'
import Login from '@/app/modules/login/Login.vue'
import Shared from '@/app/modules/shared/Shared.vue'


Vue.use(VueRouter)
Vue.use(require('vue-cookies'))

const routes = [
	{
		path: '/',
		name: 'Work',
		component: Work,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/shared/:sharedId',
		name: 'Shared',
		component: Shared,
		meta: {
			requiresAuth: false,
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	/* 	{
			path: '/404',
			name: 'NotFound',
			component: Login
		}, */
	/* 	{
			path: '*',
			redirect: "/login"
		} */
]

const router = new VueRouter({
	routes
})

//Check user auth
router.beforeEach((to, from, next) => {
	if (to.path.indexOf('creativeTaskId') !== -1) {
		let uaCreativeTaskId = to.path.split('=')[1];
		if (uaCreativeTaskId) {
			console.log("UA CreativeTaskId parsed from URL: " + uaCreativeTaskId);
			let uaCreativeTasksIds = Vue.$cookies.get("uaCreativeTasksIds");
			uaCreativeTasksIds = uaCreativeTasksIds ? JSON.parse(uaCreativeTasksIds) : [];
			if (uaCreativeTasksIds.indexOf(uaCreativeTaskId) === -1) {
				uaCreativeTasksIds.push(uaCreativeTaskId);
			}
			Vue.$cookies.set("uaCreativeTasksIds", JSON.stringify(uaCreativeTasksIds));
		}
		next('/login');
		return;
	}
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/login');
	} else {
		if (routes.some(r => to.path === r.path || to.matched.length !== 0)) {
			next();
		} else {
			next('/login');
		}

	}
})

export default router
